<template>
  <div>
    <va-modal
      id="anonLeadsModal"
      ref="anonLeadsModal"
      :value="isOpen"
      size="large"
      :showOkay="false"
      :cancelText="$t('modals.buttons.back')"
      :fixedLayout="true"
      @cancel="onCancelAnonLeadsModal">
        <div slot="header" class="modal-title">
          {{modalTitle}}
        </div>

        <div v-if="isLoading" class="d-flex align-items-center flex-column py-5">
          <span class="mb-3">{{$t('agenda.screenings.anon_leads.loading_session_data')}}</span>
          <hollow-dots-spinner
            :animation-duration="1000"
            :size="60"
            color="#29c4a9"
          />
        </div>

        <div v-else-if="sessionData !== null">

          <div v-if="sessionData.leads.length > 0" class="row">
            <div class="col-12 col-sm-4 offset-sm-1 py-3">
                <div class="d-flex flex-column align-items-center number-widget">
                  <h2>{{sessionData.leads.length}}</h2>
                  <span>{{$t('agenda.screenings.anon_leads.leads')}}</span>
                </div>
            </div>

            <div class="col-12 col-sm-4 offset-sm-2 py-3">
              <div class="d-flex flex-column align-items-center number-widget">
                <h2>{{sessionData.hearing_tests}}</h2>
                <span>{{$t('agenda.screenings.anon_leads.hearing_tests')}}</span>
              </div>
            </div>

            <div class="col-12 mt-4">
              <v-client-table
                id="anonLeadsTable"
                ref="anonLeadsTable"
                name="anonLeadsTable"
                :data="sessionData.leads"
                :columns="tableColumns"
                :options="tableOptions"
                >

                <span slot="created_at" slot-scope="{row}">
                  {{$options.filters.localTime(row.created_at, 'HH:mm')}}
                </span>

                <span slot="has_hearingLoss" slot-scope="{row}">
                  <va-popover
                    v-if="row.hasHearingLoss"
                    :message="$t('leads.table.has_hearing_loss')"
                    placement="left"
                  >
                    <i class="fa fa-check"></i>
                  </va-popover>
                </span>

                <span slot="qualified_at" slot-scope="{row}">
                  <va-popover
                    v-if="row.qualified_at"
                    :message="$t('leads.table.qualified_lead')"
                    placement="left"
                  >
                    <i class="fa fa-check"></i>
                  </va-popover>
                </span>

                <span slot="comment" slot-scope="{row}">
                  <div @click="onClickUpdateComment(row)">
                    <va-popover
                      v-if="row.comment !== null && row.comment !== ''"
                      :message="row.comment"
                      placement="left"
                    >
                      <i class="fa fa-commenting"></i>
                    </va-popover>

                    <i v-else class="fa fa-comment"></i>
                  </div>
                </span>

              </v-client-table>
            </div>
          </div>

          <div v-else class="py-5 text-center">
            <span>
              {{$t('agenda.screenings.anon_leads.no_leads')}}
            </span>
          </div>
        </div>

        <div v-else>
          {{$t('agenda.screenings.anon_leads.failed_to_load_session_data')}}
        </div>

    </va-modal>

    <va-modal
      ref="updateCommentModal"
      :value="isUpdatingComment"
      size="medium"
      :okText="$t('modals.buttons.save')"
      :cancelText="$t('modals.buttons.cancel')"
      :fixedLayout="true"
      :okDisabled="isLoadingUpdateComment"
      @ok="submitComment"
      @cancel="onCloseUpdateCommentModal"
    >
      <div slot="header" class="modal-title">
        {{updateCommentModalTitle}}
      </div>

      <va-input
        id="input-lead-comment"
        :label="$t('agenda.screenings.anon_leads.commentary')"
        type="textarea"
        :min-rows="3"
        v-model="updateCommentForm.data.comment"
      />

    </va-modal>

  </div>
</template>
<script>
import Vue from 'vue'
import { HollowDotsSpinner } from 'epic-spinners'
import { ClientTable } from 'vue-tables-2'
import { AnonLeadsService } from '@/api/LeadsService'

Vue.use(ClientTable, {}, false, 'bootstrap4')

export default {
  components: {
    HollowDotsSpinner,
  },
  props: {
    sessionUrl: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isOpen: false,
      isUpdatingComment: false,
      isLoading: true,
      isLoadingUpdateComment: false,
      selectedLead: null,
      updateCommentForm: {
        data: {
          comment: ''
        }
      },
      sessionData: null,
      tableColumns: ['created_at', 'name', 'email', 'phone', 'has_hearingLoss', 'qualified_at', 'comment'],
      tableOptions: {
        texts: {
          count: this.$t('tables.records') + ' {from} ' + this.$t('tables.to') + ' {to} ' + this.$t('tables.of') + ' {count}|{count} ' + this.$t('tables.records_') + '|' + this.$t('tables.one_record'),
          first: this.$t('tables.first'),
          last: this.$t('tables.last'),
          filter: this.$t('tables.filter') + ':',
          filterPlaceholder: this.$t('tables.search_text'),
          limit: this.$t('tables.records') + ':',
          page: this.$t('tables.page') + ':',
          noResults: this.$t('tables.no_records'),
          filterBy: this.$t('tables.filter_by') + ' {column}',
          loading: this.$t('tables.loading') + '...',
          defaultOption: this.$t('tables.select') + ' {column}',
          columns: this.$t('tables.columns_dropdown')
        },
        sortable: [],
        filterable: false,
        headings: {
          'created_at': this.$t('agenda.screenings.anon_leads.hour'),
          'name': this.$t('agenda.screenings.anon_leads.name'),
          'email': this.$t('agenda.screenings.anon_leads.email'),
          'phone': this.$t('agenda.screenings.anon_leads.phone'),
          'has_hearingLoss': this.$t('agenda.screenings.anon_leads.has_hearing_loss'),
          'qualified_at': this.$t('agenda.screenings.anon_leads.qualified_at'),
          'comment': this.$t('agenda.screenings.anon_leads.commentary')
        },
        columnsClasses: {
          comment: 'comment'
        },
      }
    }
  },
  created: function () {
    this.loadAnonLeads()
  },
  mounted () {
    this.isOpen = true
  },
  methods: {
    loadAnonLeads: function () {
      AnonLeadsService.getAnonLeadsBySession(this.sessionUrl)
        .then(sessionData => { this.sessionData = sessionData })
        .catch(errors => console.log(errors))
        .finally(() => {
          setTimeout(() => {
            this.isLoading = false
          }, 500)
        })
    },
    onCancelAnonLeadsModal: function () {
      this.isOpen = false
      this.$emit('modalClosed')
    },
    onClickUpdateComment: function (lead) {
      this.isOpen = false
      this.isUpdatingComment = true
      this.selectedLead = lead
      if (lead.comment) {
        this.updateCommentForm.data.comment = lead.comment
      }
    },
    onCloseUpdateCommentModal () {
      this.isUpdatingComment = false
      this.isOpen = true
      this.updateCommentForm.data.comment = ''
    },
    submitComment () {
      if (this.isLoadingUpdateComment) {
        return
      }
      this.isLoadingUpdateComment = true

      AnonLeadsService.updateComment(this.selectedLead.id, this.updateCommentForm.data)
        .then(lead => {
          this.updateCommentByLeadId(lead.id, lead.comment)
          this.showToast(this.$t('agenda.screenings.anon_leads.commentary_saved'), this.$store.state.successToastOptions)
          this.onCloseUpdateCommentModal()
        })
        .catch(errors => {
          console.log(errors)
          this.showToast(this.$t('agenda.screenings.anon_leads.commentary_failed'), this.$store.state.errorToastOptions)
        })
        .finally(() => {
          this.isLoadingUpdateComment = false
        })
    },
    updateCommentByLeadId: function (leadId, comment) {
      const index = this.sessionData.leads.findIndex(lead => {
        return lead.id === leadId
      })
      if (index !== -1) {
        this.sessionData.leads[index].comment = comment
        this.$forceUpdate()
      }
    }
  },
  computed: {
    modalTitle: function () {
      let title = this.$t('menu.anon_leads')
      if (this.sessionData != null) {
        const dateStr = `${this.sessionData.date} ${this.sessionData.start}:00`
        title = `${title} - ${this.sessionData.facility} - ${this.$options.filters.localTime(dateStr, 'DD/MM/YYYY HH:mm')} - ${this.sessionData.promoter}`
      }
      return title
    },
    updateCommentModalTitle: function () {
      return this.selectedLead
        ? `${this.$t('agenda.screenings.anon_leads.lead')} - ${this.$options.filters.localTime(this.selectedLead.created_at, 'HH:mm')}, ${this.selectedLead.name}`
        : ''
    }
  }
}
</script>

<style lang="scss">
  #anonLeadsModal {

    .number-widget {
      background: #f0f0f0;
      border-radius: 0.375rem;
      padding: 2rem 1rem;

      h2 {
        color: $evollu-gray-light;
      }
    }

    .table-bordered th {
      border-top: 0;
      border-left: 0;
      border-right: 0;
      border-bottom: 2px solid #cecece;
    }

    .table-bordered td {
      border: 0 !important;
    }

    .VuePagination {
      display: none !important;
    }

    .comment {
      text-align: center;
    }
  }
</style>
